export default "__VITE_ASSET__bb060766__"